import { inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { Store } from "@ngrx/store";
import { filter, map, of } from "rxjs";
import { applicationExpiredPagePath } from "src/app/shared/routes/application/term-life-insurance/application-route.constant";
import { QueryStringParameterKey } from "src/app/shared/routes/shared/shared-route.constant";
import { PermissionService } from "src/app/shared/services/permission.service";
import { AppState } from "src/app/shared/store/app.state";
import * as ApplicationActions from "src/app/shared/store/application/application.actions";
import { Product } from "src/app/shared/store/shared/product";
import * as ApplicationSelectors from "../../../shared/store/application/application.selectors";

// This guard has two responsibilities (not optimal):
// -> Load the application from the backend
// -> Check if the application has expired and otherwise redirect the user
export const getApplicationAndCheckExpirationGuard: CanActivateFn = (
  activatedRouteSnapshot: ActivatedRouteSnapshot,
  _: RouterStateSnapshot,
) => {
  const router = inject(Router);
  const store = inject(Store<AppState>);
  const applicationIdUrl = activatedRouteSnapshot.queryParamMap.get(
    QueryStringParameterKey.APPLICATION_ID,
  );
  const permissionService = inject(PermissionService);
  const redirectRoute = router.parseUrl(applicationExpiredPagePath);

  // For anything application specific we require an 'applicationId' in the url
  // Otherwise we do not allow access to the route
  if (applicationIdUrl) {
    // Fire & Forget
    store.dispatch(
      ApplicationActions.getApplication({
        applicationId: applicationIdUrl,
        product: Product.TERM_LIFE_INSURANCE_CONSTANT, // TODO: Refactor this hard coded value, once we refactor the frontend for the new pillar 3 product
      }),
    );

    // Wait until the http request has returned to check if the application has expired or not
    return store.select(ApplicationSelectors.selectHttpRequestState).pipe(
      filter((httpRequestState) => httpRequestState.isBusy === false),
      map((httpRequestState) => {
        const hasApplicationExpired = permissionService.hasApplicationExpired(
          httpRequestState.error,
        );
        return hasApplicationExpired ? redirectRoute : true;
      }),
    );
  }

  return of(redirectRoute);
};
